import BackToTop from './BackToTop.js'

BackToTop.register()
